export class CategorizationAnnotationPanelState {
  isOpen = false;
}
